import React from 'react';
import PropTypes from 'prop-types';

/**
 * SVG sort indicator icon that renders an up or down chevron.
 * Used in sortable table headers to indicate the current sort direction.
 *
 * @param {Object} props
 * @param {'asc'|'desc'|null} props.direction - Sort direction: 'asc' for up chevron, 'desc' for down chevron, null to hide
 * @param {string} [props.className] - Optional additional CSS class name
 * @returns {JSX.Element|null} Sort icon span or null when direction is null
 * @example
 * <SortIcon direction="asc" />
 * <SortIcon direction={sortDirection} className="my-sort" />
 */
function SortIcon({ direction = null, className = '' }) {
  if (!direction) return null;

  const classes = ['sort-icon', className].filter(Boolean).join(' ');

  return (
    <span className={classes}>
      {direction === 'asc' ? (
        <svg viewBox="0 0 10 6" aria-hidden="true">
          <path d="M5 0L10 6H0z" />
        </svg>
      ) : (
        <svg viewBox="0 0 10 6" aria-hidden="true">
          <path d="M5 6L0 0h10z" />
        </svg>
      )}
    </span>
  );
}

SortIcon.propTypes = {
  /** Sort direction: 'asc' for up, 'desc' for down, null to hide */
  direction: PropTypes.oneOf(['asc', 'desc', null]),
  /** Optional additional CSS class */
  className: PropTypes.string,
};

export default SortIcon;
